export default __webpack_public_path__ + "static/media/WhyGSDInsight_HeroBanner.780e851d.png";